module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadData),
      expression: "loadData"
    }],
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "id": "contacts-index",
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('groups.title.index')))]), _c('div', {
    staticClass: "dropdown pull-right"
  }, [(!_vm.current_user.isMonitoringManager()) ? _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _c('span', [_vm._v(_vm._s(_vm.$t('groups.actions.create.newGroup')))])]) : _vm._e(), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/grupos-de-contatos/importar/manualmente'
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.manuallyAdd')))])], 1), _c('li', {
    attrs: {
      "id": "new-group"
    },
    on: {
      "click": _vm.openNewGroupModal
    }
  }, [_c('a', {
    staticClass: "clickable",
    attrs: {
      "id": "open-new-group"
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.contactBaseAdd')))])])])])]), _c('div', {
    staticClass: "clear"
  }), (_vm.showNabBars()) ? _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "tab-list",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.leadsRedirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.contacts')))])]), _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.groupsRedirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.groups')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.businessRedirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.businesses')))])])])]) : _vm._e(), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "groups-tab"
    }
  }, [_c('contact-groups-list', {
    attrs: {
      "contact_groups": _vm.contact_groups,
      "filters": _vm.filters,
      "view_mode": _vm.contactGroupListViewModes().index
    },
    on: {
      "group-destroy": _vm.openDestroyGroupConfirmationModal,
      "filter": _vm.filter
    }
  })], 1)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1), _c('go-to-top'), _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-group",
      "title": _vm.$t('groups.actions.delete.title'),
      "confirm_text": _vm.$t('groups.actions.delete.confirm'),
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.destroyGroup
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-left"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('groups.actions.delete.confirmBelow'))), _c('div', {
    staticClass: "delete-group-option"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        _vm.group_destroy_contacts = false
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": !_vm.group_destroy_contacts
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('groups.actions.delete.checkboxConfirm')) + "  "), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.selected_group.name))])])])]), _c('div', {
    staticClass: "delete-group-option"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        _vm.group_destroy_contacts = true
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.group_destroy_contacts
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('groups.actions.delete.checkboxConfirm')) + "  "), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.selected_group.name) + " " + _vm._s(_vm.$t('groups.actions.delete.andAllContacts')))])])])])])])]), _c('new-group-modal', {
    on: {
      "contact-group-saved": _vm.updateContactGroupList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b826234!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/groups.vue
// module id = 1106
// module chunks = 1